import {
  isAxiosError,
} from 'axios';
import type {
  AxiosError,
} from 'axios';

export const RETRY_CONFIG = {
  maxRetries: 3,
  baseRetryDelay: 1000,
  maxRetryDelay: 5000,
};

const RETRYABLE_AXIOS_CODES = [
  'ERR_NETWORK',
  'ECONNABORTED',
  'ETIMEDOUT',
];

function isRetryableAxiosCode(code: string | undefined) {
  return RETRYABLE_AXIOS_CODES.includes(code ?? '');
}

export function isRetryableLoggedInUserInfoError(error: unknown): boolean {
  if (!isAxiosError(error)) {
    return false;
  }

  const axiosError = error as AxiosError;

  return isRetryableAxiosCode(axiosError?.code)
    || axiosError?.message === 'Network Error'
    || axiosError?.message?.toLowerCase()?.includes('timeout');
}

export function getLoggedInUserInfoRetryDelay(attemptIndex: number): number {
  return Math.min(
    RETRY_CONFIG.baseRetryDelay * (2 ** attemptIndex),
    RETRY_CONFIG.maxRetryDelay,
  );
}
